/** This slice is for data used commonly in nearly ever component of our application */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	retailerId: null,
	userId: null,
	accessCode: null,
	docMode: false,
	knumber: null,
	acceptedFileTypes: [],
	inputSource: ['dt', 'gp', 'fb'], // dt=local file picker,gp=google photos, fb=facebook photos.
	hostName: null,
	localDomain: null,
	userDeviceData: {},
};

export const commonSlice = createSlice({
	name: 'common',
	initialState: initialState,
	reducers: {
		setUserId: (state, action) => {
			state.userId = action.payload;
		},
		setKnumber: (state, action) => {
			state.knumber = action.payload;
		},
		setRetailerId: (state, action) => {
			state.retailerId = action.payload;
		},
		setAccessCode: (state, action) => {
			state.accessCode = action.payload;
		},
		setDocMode: (state, action) => {
			state.docMode = action.payload;
		},
		setAcceptedFileTypes: (state, action) => {
			state.acceptedFileTypes = action.payload;
		},
		setInputSource: (state, action) => {
			state.inputSource = action.payload;
		},
		setHostName: (state, action) => {
			state.hostName = action.payload;
		},
		setLocalDomain: (state, action) => {
			state.localDomain = action.payload;
		},
		setUserDeviceData: (state, action) => {
			state.userDeviceData = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setAccessCode,
	setRetailerId,
	setUserId,
	setDocMode,
	setAcceptedFileTypes,
	setInputSource,
	setKnumber,
	setHostName,
	setLocalDomain,
	setUserDeviceData,
} = commonSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectRetailerId = (state) => state.common.retailerId;
export const selectAccessCode = (state) => state.common.accessCode;
export const selectUserId = (state) => state.common.userId;
export const selectKnumber = (state) => state.common.knumber;
export const selectDocMode = (state) => state.common.docMode;
export const selectInputSource = (state) => state.common.inputSource;
export const selectAcceptedFileTypes = (state) =>
	state.common.acceptedFileTypes;
export const selectHostName = (state) => state.common.hostName;
export const selectLocalDomain = (state) => state.common.localDomain;
export const selectUserDeviceData = (state) => state.common.userDeviceData;

export default commonSlice.reducer;
